import React from 'react';

import Icon, { Props } from './icon';
export const OpenFullscreenIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40" fill="none">
      <path
        d="M13.4049 24.2383C14.0558 23.5874 15.1108 23.5874 15.7617 24.2383C16.4126 24.8892 16.4126 25.9442 15.7617 26.5951L9.02342 33.3334H13.3333C14.2538 33.3334 15 34.0796 15 35C15 35.9205 14.2538 36.6667 13.3333 36.6667H4.99998C4.55795 36.6667 4.13415 36.491 3.82159 36.1784C3.50903 35.8659 3.33331 35.4421 3.33331 35V26.6667C3.33331 25.7462 4.07951 25 4.99998 25C5.92045 25 6.66665 25.7462 6.66665 26.6667V30.9766L13.4049 24.2383Z"
        fill="#F2F2F2"
      />
      <path
        d="M35 25C35.9204 25 36.6666 25.7463 36.6666 26.6667V35C36.6666 35.442 36.4909 35.8659 36.1784 36.1784C35.8658 36.491 35.442 36.6667 35 36.6667H26.6666C25.7462 36.6667 25 35.9205 25 35C25.0001 34.0796 25.7462 33.3334 26.6666 33.3334H33.3333V26.6667C33.3334 25.7463 34.0796 25 35 25Z"
        fill="#F2F2F2"
      />
      <path
        d="M35 3.33826C35.9205 3.33826 36.6666 4.08445 36.6666 5.00492V13.3383C36.6662 14.2584 35.9202 15.0049 35 15.0049C34.0798 15.0049 33.3337 14.2584 33.3333 13.3383V9.02836L26.595 15.7666C25.9443 16.417 24.889 16.417 24.2383 15.7666C23.5874 15.1158 23.5874 14.0591 24.2383 13.4082L30.9749 6.67159H26.6666C25.7464 6.67159 25.0004 5.92506 25 5.00492C25 4.08445 25.7462 3.33826 26.6666 3.33826H35Z"
        fill="#F2F2F2"
      />
      <path
        d="M13.3333 3.33337C14.2538 3.33337 15 4.07957 15 5.00004C15 5.92052 14.2538 6.66671 13.3333 6.66671H6.66665V13.3334C6.66665 14.2538 5.92045 15 4.99998 15C4.07951 15 3.33331 14.2538 3.33331 13.3334V5.00004C3.33331 4.55801 3.50903 4.13422 3.82159 3.82166C4.13415 3.50909 4.55795 3.33337 4.99998 3.33337H13.3333Z"
        fill="#F2F2F2"
      />
    </Icon>
  );
};

export default React.memo(OpenFullscreenIcon);
